import type {
  NotificationPolicy,
  NotificationPolicyTypeEnum,
} from '@repo/api-gw-sdk';

import { NotificationPolicyCredentials } from './notificationPolicyCredentials';
import { NotificationPolicyNameSelection } from './notificationPolicyNameSelection';
import { NotificationPolicyNotifications } from './notificationPolicyNotifications';

import type { Step } from '../wizard/Step';

export type UpsertNotificationPolicyState = NotificationPolicy & {
  type: NotificationPolicyTypeEnum | undefined;
};

export const upsertNotificationPolicyFlow: Step<UpsertNotificationPolicyState> =
  {
    id: 'name_selection',
    Component: NotificationPolicyNameSelection,
    nonReturnable: true,
    next: [
      {
        id: 'credentials',
        Component: NotificationPolicyCredentials,
        next: [
          {
            id: 'notifications',
            Component: NotificationPolicyNotifications,
          },
        ],
      },
    ],
  };
